import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PayoutOrderListItemResponse } from '@/models/payout-order/payout-order-list.model';
import { RequestListPayload } from '@/models/common/request-list-payload.model';
import { PayoutOrderListFilter } from '@/models/payout-order/payout-order-list-filter.model';
import { clearObj } from '@marfa/bo-utils';
import { ResponseWithHeaders } from '@/models/common/response-with-header.model';

export class GetPayoutOrderListRequest extends ApiResourceMethod<ResponseWithHeaders<PayoutOrderListItemResponse[]>> {
  public perform(
    whitelabelSlug: string,
    payload: RequestListPayload<PayoutOrderListFilter>,
  ): Promise<ResponseWithHeaders<PayoutOrderListItemResponse[]>> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/v2/dashboard/payoutOrder`,
        params: clearObj(payload),
      },
      ({ data, headers }: BaseResponse<PayoutOrderListItemResponse[]>):
      ResponseWithHeaders<PayoutOrderListItemResponse[]> => ({
        data,
        headers,
      }),
    );
  }
}
